import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/users/$userId/organizations")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
